import { blastSourceColor } from '../../../Model/Project/blastSourceVisuals.ts'

/**
 * A taxonomy source's mark in its colour: a target for the derived Consensus, a hexagon for BOLD (its BIN logo
 * shape), a database cylinder for the sequence databases.
 */
export const BlastSourceIcon = ({ source, size = 28 }: { source: string; size?: number }) => {
  const color = blastSourceColor(source)
  const key = source.toLowerCase()
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className="shrink-0">
      {key === 'consensus' ? (
        <>
          <circle cx="16" cy="16" r="13" fill="none" stroke={color} strokeWidth="3" />
          <circle cx="16" cy="16" r="7.5" fill="none" stroke={color} strokeWidth="3" />
          <circle cx="16" cy="16" r="2.8" fill={color} />
        </>
      ) : key === 'bold' ? (
        <>
          <polygon points="16,2 28,9 28,23 16,30 4,23 4,9" fill={color} />
          <text x="16" y="21" textAnchor="middle" fontSize="14" fontWeight="700" fill="white" fontFamily="sans-serif">
            B
          </text>
        </>
      ) : (
        <>
          <ellipse cx="16" cy="7" rx="11" ry="4" fill={color} />
          <path d="M5 7v18c0 2.2 4.9 4 11 4s11-1.8 11-4V7c0 2.2-4.9 4-11 4S5 9.2 5 7z" fill={color} opacity="0.85" />
          <path d="M5 13c0 2.2 4.9 4 11 4s11-1.8 11-4M5 19c0 2.2 4.9 4 11 4s11-1.8 11-4" fill="none" stroke="white" strokeWidth="1.5" />
        </>
      )}
    </svg>
  )
}
